module.exports = __webpack_public_path__ + "static/evernote-4ee30cda0fb86f234c17e7942d851189.png";